/// <amd-module name="Wiki/Renderer/ImageTransformer" />
import { startsWith } from "VSS/Core/Util/String";
import { IVssPageContext } from "VSS/Platform/Context";
import { Uri } from "VSS/Platform/Util/Url";

import { isAbsoluteUrl } from "VSS/Features/Markdown/Utils/UrlHelper";

import { GitVersionDescriptor } from "Wiki/Clients/VC/Contracts/Git";
import * as VCPathHelper from "Wiki/Renderer/VCPathHelper";
import { getGitFileContentUrl } from "Wiki/Renderer/VCUrlHelper";
import { RepoConstants } from "Wiki/ViewCommon/Constants";
import { Attachment } from "Wiki/ViewCommon/Contracts";
import { getFileName, getGitItemPath } from "Wiki/ViewCommon/Utils/PathHelper";

export class ImageTransformer {
    constructor(
        private _pageContext: IVssPageContext,
        private _projectId: string,
        private _repositoryId: string,
        private _versionDescriptor: GitVersionDescriptor | undefined,
        private _wikiRootPath: string
    ) {}

    public transformImage(src: string, attachmentsMap?: { [key: string]: Attachment }, currentPagePath: string = ""): string {
        if (!src || isAbsoluteUrl(src)) {
            // Even for absolute URL, we need unescaped URL, as before making request URL will be escaped again
            try {
                src = decodeURIComponent(src);
            } catch (e) {
                // URI is malformed, do not decode
            }

            return src;
        }

        // Decoding absoluteUri to support file names having any unicode characters
        const imagePath = decodeURIComponent(new Uri(src).absoluteUri);
        const imageFileName = getFileName(imagePath);

        if (attachmentsMap) {
            const attachment = attachmentsMap[imageFileName];
            if (attachment) {
                return attachment.objectUrl;
            }
        }

        const gitItemPathOfPage = getGitItemPath(currentPagePath, this._wikiRootPath);
        const wikiRootDirectory = this._wikiRootPath === RepoConstants.RootPath ? this._wikiRootPath : this._wikiRootPath + RepoConstants.RootPath;
        // We consider paths starting with "/" and ".attachments" both as absolute paths, else relative
        const imageBasePath =
            startsWith(imagePath, RepoConstants.RootPath) || startsWith(imagePath, RepoConstants.AttachmentsFolder.substr(1))
                ? wikiRootDirectory
                : gitItemPathOfPage;
        const imageRelativePath = startsWith(imagePath, RepoConstants.RootPath) ? imagePath.substr(1) : imagePath;
        const absoluteImagePath = VCPathHelper.combine(imageBasePath, imageRelativePath);

        return getGitFileContentUrl(this._pageContext, this._projectId, this._repositoryId, this._versionDescriptor, absoluteImagePath, true);
    }
}
